import React, { useState, useEffect, useRef } from "react";
import "../css/Chatpopup.css";
import reportChatIcon from '../img/reportchatbotIcon.jpg';
import user from '../img/user.png';
import { retrieveMineData } from '../Utility/ConsumeToken/consumeToken';
import { MdSend } from "react-icons/md";
import {
    enqueueDeepsageReasoningRequest,
    checkDeepsageReasoningStatus,
    getDeepsageReasoningOutput
} from '../Utility/Deepsage/deepsageReasoningUtils';
import { useGID } from '../context/GIDContext';

const ReportChat = ({ isOpen, onClose }) => {
    const { gid } = useGID();
    const [messages, setMessages] = useState([{
        sender: "assistant",
        text: "Hi there! I'm the Deepsage Report Assistant, designed specifically to help you analyze your report. I can provide detailed insights, explain trends, and answer any questions related to your data. What would you like to know about your report?",
    }]);

    const [inputMessage, setInputMessage] = useState("");
    const chatAreaRef = useRef(null);

    useEffect(() => {
        if (chatAreaRef.current) {
            chatAreaRef.current.scrollTop = chatAreaRef.current.scrollHeight;
        }
    }, [messages]);

    const sendMessage = async () => {
        if (inputMessage.trim() === "") return;
        const apitoken = await retrieveMineData();
        const userMessage = { sender: "user", text: inputMessage };
        setMessages(prevMessages => [...prevMessages, userMessage]);
        const query = inputMessage;
        setInputMessage("");

        const GID = gid;
        const CID = "Chat";
        const IDD = apitoken._id;
        const token = "000111";

        try {
            const enqueueResponse = await enqueueDeepsageReasoningRequest(GID, CID, IDD, query, token);
            if (enqueueResponse.output !== "ENQUEUED") {
                throw new Error("Enqueue failed: " + enqueueResponse.reason);
            }

            // Aggiungo il messaggio "typing" per indicare che l'assistente sta elaborando
            const typingIndicator = { sender: "assistant", text: "Assistant is typing..." };
            setMessages(prevMessages => [...prevMessages, typingIndicator]);

            let completed = false;
            while (!completed) {
                await new Promise(resolve => setTimeout(resolve, 1000));
                const statusResponse = await checkDeepsageReasoningStatus(GID, CID, IDD, query, token);
                if (statusResponse.output === "REQUEST COMPLETED") {
                    completed = true;
                }
            }

            const outputResponse = await getDeepsageReasoningOutput(GID, CID, IDD, query, token);
            let lastMessageText = "";
            let parsedOutput;
            try {
                parsedOutput = typeof outputResponse.output === "string"
                    ? JSON.parse(outputResponse.output)
                    : outputResponse.output;
            } catch (e) {
                parsedOutput = [];
            }

            if (Array.isArray(parsedOutput) && parsedOutput.length > 0) {
                lastMessageText = parsedOutput[parsedOutput.length - 1].risposta || "No response text.";
            } else {
                lastMessageText = "No response received.";
            }

            // Rimuovo il messaggio "typing" e aggiungo la risposta definitiva
            setMessages(prevMessages => {
                const messagesWithoutTyping = prevMessages.slice(0, -1);
                return [...messagesWithoutTyping, { sender: "assistant", text: lastMessageText }];
            });
        } catch (error) {
            console.error("Error sending message:", error);
            setMessages(prevMessages => [
                ...prevMessages,
                { sender: "assistant", text: "I'm sorry! Error processing your request." }
            ]);
        }
    };

    const handleKeyPress = (e) => {
        if (e.key === "Enter" && !e.shiftKey) {
            e.preventDefault();
            sendMessage();
        }
    };

    const clearChat = () => {
        const initialMessage = {
            sender: "assistant",
            text: "Hi there! I'm the Deepsage Report Assistant, designed specifically to help you analyze your report. I can provide detailed insights, explain trends, and answer any questions related to your data. What would you like to know about your report?",
        };
        setMessages([initialMessage]);
    };

    const formatMessage = (message) => {
        let formattedText = message
            .replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>")
            .replace(/(?:\r\n|\r|\n)/g, "<br />")
            .replace(/^\d+\.\s(.*?)$/gm, "<li>$1</li>")
            .replace(/^- (.*?)$/gm, "<li>$1</li>");

        if (formattedText.includes("<li>")) {
            formattedText = formattedText.replace(/(<li>.*?<\/li>)/g, "<ul>$1</ul>");
        }

        return formattedText;
    };

    if (!isOpen) return null;

    return (
        <div className="big-popup-report">
            <div className="popup-header-reportchat">
                <div className="popup-header-inner">
                    <img src={reportChatIcon} alt="Report Assistant" className="chatbot-icon-message" />
                    <h2 className="titoloAI text-color-dark">Report Assistant</h2>
                </div>
                <div>
                    <button className="button clear-button background-dark" onClick={clearChat}>Clear Chat</button>
                    <button className="button close-button text-color-dark border-dark" onClick={onClose}>Close Chat</button>
                </div>
            </div>
            <div className="chat-area" ref={chatAreaRef}>
                {messages.map((message, index) => (
                    <React.Fragment key={index}>
                        <div className="space"></div>
                        <div className={`message ${message.sender === "user" ? "user-message-group" : "assistant-message-group"}`}>
                            {message.sender === "assistant" && (
                                <img src={reportChatIcon} alt="Report Assistant" className="chatbot-icon-message" />
                            )}
                            <div className={`chat-message ${message.sender === "user" ? "user-message" : "assistant-message"}`} dangerouslySetInnerHTML={{ __html: formatMessage(message.text) }} />
                            {message.sender === "user" && (
                                <img src={user} alt="User Icon" className="user-icon-message" />
                            )}
                        </div>
                    </React.Fragment>
                ))}
            </div>
            <div className="chat-body-report">
                <label>Hi there! Type your query regarding the report below.</label>
                <div className="chat-input">
                    <textarea
                        placeholder="Type your query..."
                        value={inputMessage}
                        onChange={(e) => setInputMessage(e.target.value)}
                        onKeyDown={handleKeyPress}
                    />
                    <button className="button background-dark" onClick={sendMessage}><MdSend size={25} /></button>
                </div>
            </div>
        </div>
    );
};

export default ReportChat;
